export const gtmPush = (event, payload = {}) => {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];

  const basePayload = {
    event,
    page_path: window.location.pathname + window.location.hash,
    page_title: document.title,
    timestamp: new Date().toISOString(),
  };

  const enrichedPayload = {
    ...basePayload,
    ...payload,
  };

  window.dataLayer.push(enrichedPayload);

  if (typeof window.gtag === "function") {
    const gtagPayload = {
      event_category: payload.event_category || "engagement",
      event_label:
        payload.event_label ||
        payload.link_name ||
        payload.platform ||
        payload.form_name ||
        payload.element ||
        payload.destination ||
        payload.url ||
        "",
      page_path: enrichedPayload.page_path,
      page_title: enrichedPayload.page_title,
      ...payload,
    };

    window.gtag("event", event, gtagPayload);
  }
};

export const trackExternalLink = (eventName, platform, url, extra = {}) => {
  gtmPush(eventName, {
    platform,
    url,
    link_type: "external",
    event_category: "outbound",
    event_label: platform,
    ...extra,
  });
};

export const trackClick = (eventName, element, extra = {}) => {
  gtmPush(eventName, {
    element,
    event_category: "click",
    event_label: element,
    ...extra,
  });
};
